import React, { createContext, useContext, useEffect, useState } from "react";
import { getSiteData } from "../lib/api";

const EMPTY = { outlets: [], software: [], gallery: [], news: [], vacancies: [], images: [] };

const SiteDataContext = createContext({ data: EMPTY, loading: true, loaded: false });

// Fetches real, admin-editable content once on app load. Pages read from
// this instead of calling the API themselves. If the backend is down or
// unreachable, `data` stays EMPTY and `loaded` stays false — pages should
// fall back to their own mock constants in that case rather than showing a
// broken/blank section.
export function SiteDataProvider({ children }) {
  const [state, setState] = useState({ data: EMPTY, loading: true, loaded: false });

  useEffect(() => {
    let cancelled = false;
    getSiteData()
      .then((data) => { if (!cancelled) setState({ data, loading: false, loaded: true }); })
      .catch(() => { if (!cancelled) setState({ data: EMPTY, loading: false, loaded: false }); });
    return () => { cancelled = true; };
  }, []);

  return <SiteDataContext.Provider value={state}>{children}</SiteDataContext.Provider>;
}

export function useSiteData() {
  return useContext(SiteDataContext);
}
